import { FigureVarSettings, isFigureVarSettings } from "./FigureVarSettings";

export interface FigureLegendSettings {
  legendType: string;
  parameters: FigureVarSettings[];
}

/**
 * Type guard to check if an object is a FigureTypeLegendSettings
 *
 * @param obj - The object to check
 * @returns true if the object is a FigureTypeLegendSettings
 */
export const isFigureLegendSettings = (obj: unknown): obj is FigureLegendSettings => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureLegendSettings;
  if (typeof chkObj.legendType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.parameters)) {
    return false;
  }
  if (chkObj.parameters.some((param) => !isFigureVarSettings(param))) {
    return false;
  }
  return true;
};
